import { TestProps } from './Test';

export const TestB = ({ name }: TestProps) => {
  return <p>Ciao {name} (B)</p>;
};
